var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_40_12935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24 12C24 18.6243 18.6243 24 12 24C5.37566 24 0 18.6243 0 12C0 5.37566 5.37566 0 12 0C18.6243 0 24 5.37566 24 12Z",
    fill: "#D18915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.5792 12.0005C23.5792 18.3921 18.394 23.5773 12.0025 23.5773C5.61097 23.5773 0.425781 18.3921 0.425781 12.0005C0.425781 5.60901 5.61097 0.423828 12.0025 0.423828C18.394 0.423828 23.5792 5.60901 23.5792 12.0005Z",
    fill: "#FCCB37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.2,
    d: "M24 12C24 18.6243 18.6243 24 12 24V0C18.6243 0 24 5.37566 24 12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.6331 12.0002C20.6331 16.7621 16.7601 20.6351 11.9982 20.6351C7.2363 20.6351 3.36328 16.7621 3.36328 12.0002C3.36328 7.23825 7.2363 3.36523 11.9982 3.36523C16.7813 3.36523 20.6331 7.23825 20.6331 12.0002Z",
    fill: "#D18915"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.3008 8.16997V7.02711H10.5389H8.71875V8.16997H10.5389C11.3219 8.16997 11.978 8.67791 12.2108 9.37632H8.71875V10.5192H12.232C11.9992 11.2176 11.3431 11.7255 10.56 11.7255H8.73991V12.8684H9.0997C9.64997 12.8684 10.2002 13.0165 10.687 13.2917C11.5547 13.7996 12.8034 14.879 13.523 16.9954H14.7293C13.9886 14.6673 12.7399 13.334 11.7029 12.6144C12.5494 12.2335 13.2055 11.4504 13.396 10.5192H15.3008V9.37632H13.396C13.3113 8.93188 13.1209 8.52976 12.8457 8.16997H15.3008Z",
    fill: "#FCCB37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.2,
    d: "M20.6349 12.0003C20.6349 16.7622 16.7619 20.6352 12 20.6352V3.36535C16.7831 3.36535 20.6349 7.23837 20.6349 12.0003Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40_12935"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.aeb2b754c6cc6600990c7d303ddadbad.svg";
export { ForwardRef as ReactComponent };